var path = '/app/core/directives/tlp/tlp.html';
var html = "<span class=\"label label-lg {{tlpClass}}\">{{tlp}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/core/directives/tlp/tlp.html
// module id = 281
// module chunks = 0